import { defineComponent as _defineComponent } from 'vue'
import { DrawPlankColor } from '@/data/plank'
import { Plank } from '@/util/canvas/drawPlank'
import { plankDrawFactory } from '@/util/drawPlank'
import { onMounted, ref } from 'vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'drawItem',
  props: {
    plankInfo: null,
    arrIndex: null,
    plankIndex: null
  },
  setup(__props: any) {

const props = __props as {
  plankInfo: any
  arrIndex?: number
  plankIndex?: number
}



const rect = ref({
  width: 155,
  height: 310,
})
const canvasRef = ref()

onMounted(() => {
  if (props.plankInfo) {
    startDraw()
  }
})

function startDraw() {
  const ctx = canvasRef.value.getContext('2d')
  const { defaultScale, startX, startY } = calcStartPos()
  const { plankInfo: plank } = props
  const draws = plankDrawFactory(
    ctx,
    plank,
    startX,
    startY,
    defaultScale,
    1,
    undefined,
    ['plankSize']
  )
  const draw = new Plank(ctx, plank, startX, startY, defaultScale, 1, undefined)
  draw.addStrategy(
    Object.keys(draws).map(
      (it) => draws[it as keyof ReturnType<typeof plankDrawFactory>]
    )
  )
  draw.setFillStyle(DrawPlankColor.normal)
  draw.draw()
}

// const d:ReturnType<typeof plankDrawFactory>
//   d.
/** 计算绘制所需要的比例以及相关起点位置 */
function calcStartPos() {
  const { plankInfo: plank } = props
  // 绘制矩形缩小一点
  const width = rect.value.width - 35
  const height = rect.value.height - 35
  // defaultScale 默认的缩放比例
  const defaultScale = Math.max(
    plank.rect.width / width,
    plank.rect.height / height
  )
  const sw = plank.rect.width / defaultScale
  const sh = plank.rect.height / defaultScale
  const startX = (rect.value.width - sw) / 2
  const startY = (rect.value.height - sh) / 2
  return { defaultScale, startX, startY }
}

return { __sfc: true,props, rect, canvasRef, startDraw, calcStartPos }
}

})